import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';

export const StyledSectionPage = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
`;

export const StyledSectionTitle = styled.div`
  text-align: left;
  width: ${scaleSize(282)}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
